/**
 * Leaf module (imports nothing) that breaks the `RxSocket -> Auth` import cycle.
 *
 * `Auth` is a high-level orchestrator; low-level services such as `RxSocket` only need its
 * `logoutOnExpiredSession` handler, but importing `Auth` directly drags the whole
 * `Auth -> AuthCleanUp / Login / LoginCustomNotifications -> feature services` hub into a cycle.
 * `Auth` registers the handler here at module load; `RxSocket` calls it through this bridge instead.
 * Mirrors the existing `History.registerSearchByQuery` injection.
 *
 * `Auth` is loaded at app bootstrap, well before any websocket session-expiry can fire, so the
 * handler is always registered by the time it is invoked. Unregistered is a safe no-op.
 */
let _logoutOnExpiredSession = null;

export const registerLogoutOnExpiredSession = (fn) => {
  _logoutOnExpiredSession = fn;
};

export const logoutOnExpiredSession = (...args) => _logoutOnExpiredSession?.(...args);
